// extracted by mini-css-extract-plugin
export default {"slider":"Toggle_slider__WSn1b","switch":"Toggle_switch__ELHLf","switchInput":"Toggle_switchInput__oZV9Y"};